import React from 'react';

export const AutoComplete = () => {
  return <div>AutoComplete</div>;
};
